export default __webpack_public_path__ + "static/media/electronics.10704dd6.png";